import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import twoWheeler from "../../../assets/two_wheeler.webp";
import threeWheeler from "../../../assets/three_wheeler.webp";
import fourWheeler from "../../../assets/four_wheeler.webp";
import miniTruck from "../../../assets/mini_truck.webp";

const OtherServices = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const selectedCity = location.state?.city || "Delhi";
  const selectedVehicle = location.state?.vehicle || "Two Wheeler";

  const services = [
    {
      label: "Two Wheeler",
      icon: twoWheeler,
      type: "vehicle",
    },
    {
      label: "Three Wheeler",
      icon: threeWheeler,
      type: "vehicle",
    },
    {
      label: "Four Wheeler",
      icon: fourWheeler,
      type: "vehicle",
    },
    {
      label: "Mini Truck",
      icon: miniTruck,
      type: "vehicle",
    },
  ];

  const visibleServices = services.filter(
    (service) => service.label !== selectedVehicle,
  );

  const handleServiceClick = (service) => {
    if (service.type === "vehicle") {
      navigate("/bookings", {
        state: {
          city: selectedCity,
          vehicle: service.label,
        },
      });

      return;
    }

    navigate("/contact-us");
  };

  return (
    <section className="w-full bg-white px-4 py-14">
      <div className="mx-auto max-w-5xl text-center">
        <div className="mb-8">
          <span className="mb-3 inline-flex rounded-full bg-blue-50 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-blue-700">
            More Options
          </span>

          <h2 className="text-2xl font-bold text-slate-900 md:text-3xl">
            Other Services to Choose From
          </h2>

          <p className="mx-auto mt-3 max-w-[520px] text-sm leading-6 text-slate-500">
            You selected{" "}
            <span className="font-semibold text-blue-700">
              {selectedVehicle}
            </span>
            . Here are the other available services.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-5">
          {visibleServices.map((service) => (
            <button
              key={service.label}
              type="button"
              onClick={() => handleServiceClick(service)}
              className="group flex h-[175px] w-[150px] flex-col items-center justify-center rounded-3xl border border-blue-50 bg-[#eef3ff] px-4 py-5 text-center shadow-sm transition hover:-translate-y-1 hover:border-blue-200 hover:bg-white hover:shadow-xl sm:h-[185px] sm:w-[165px]"
            >
              <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-white shadow-sm transition group-hover:bg-blue-50">
                <img
                  src={service.icon}
                  alt={service.label}
                  className="h-[48px] w-[58px] object-contain"
                />
              </div>

              <h3 className="mb-4 min-h-[38px] text-sm font-bold leading-5 text-slate-800">
                {service.label}
              </h3>

              <span className="flex h-8 w-12 items-center justify-center rounded-full bg-blue-600 text-sm font-semibold text-white transition group-hover:bg-blue-700">
                →
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OtherServices;
